import { render, staticRenderFns } from "./AcceptMeeting.vue?vue&type=template&id=124c88c2&"
import script from "./AcceptMeeting.vue?vue&type=script&lang=js&"
export * from "./AcceptMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports